import React from "react";
import ReactDOM from "react-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App'

ReactDOM.render(
    <>
        <ToastContainer autoClose={2500} />
        <App />
    </>
    ,document.getElementById("root"));
